export const INSTRUCTION_VIEWED = 'INSTRUCTION_VIEWED';
export const LOCAL_STORAGE_CAMPAIGN_QUESTION_LOG = 'swipeguide_campaign_log';
export const LOCAL_STORAGE_CAMPAIGNS_QUESTION_LOG_VERSION = '20210622';

export const getEmptyLocalStorageLogStructure = () => ({
  campaigns: {version: LOCAL_STORAGE_CAMPAIGNS_QUESTION_LOG_VERSION}
});
